export const dsaCompliance = `
# DSA Megfelelőség és Jelölések

Ez az alkalmazás a GoSchool-AI Kft. által kerül forgalomba, amely a Digitális Szolgáltatásokról szóló uniós rendelet (DSA) értelmében kereskedőként jár el.

## Címkék és Jelölések

- Az alkalmazásra nem vonatkozik korhatár-besorolás, kivéve, ha azt az App Store másként jelzi.
- Az alkalmazás felhasználói tartalmakat tartalmaz, amelyeket tanárok töltenek fel. Minden felhasználónk köteles betartani a [Felhasználási Feltételeket](/terms-of-use), és igazolniuk kell, hogy rendelkeznek a tartalom feltöltéséhez szükséges jogokkal.
- A szolgáltatás nem tartalmaz veszélyes, korlátozott vagy szabályozott termékeket.

## Kereskedői Információk

GoSchool-AI Kft.  
Székhely: 1121 Budapest, Ordas köz 2.  
E-mail: info@goschool.ai  
Adószám: 32622922-2-43

## Kapcsolat a Megfelelőség Kapcsán

A Digitális Szolgáltatásokról szóló rendelettel kapcsolatos megkereséseket az alábbi e-mail címen fogadjuk:  
legal@goschool.ai

Hatályos: 2024.08.30
`
